import { render, staticRenderFns } from "./UserListAdd.vue?vue&type=template&id=516087ba"
import script from "./UserListAdd.vue?vue&type=script&lang=js"
export * from "./UserListAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports